import { render, staticRenderFns } from "./tiwen.vue?vue&type=template&id=21078f52&scoped=true&"
import script from "./tiwen.vue?vue&type=script&lang=ts&"
export * from "./tiwen.vue?vue&type=script&lang=ts&"
import style0 from "./tiwen.vue?vue&type=style&index=0&id=21078f52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21078f52",
  null
  
)

export default component.exports